import React from 'react';
import { Box, Divider } from '@mui/material';
import { Backdoor } from '../common/Backdoor';
import { PageHeaderBar } from './PageHeaderBar';
import { APP_SHELL_HEADER_BORDER } from './layoutConstants';

interface DetailPageHeaderProps {
  title: string;
  actions?: React.ReactNode;
  showDivider?: boolean;
}

export const DetailPageHeader: React.FC<DetailPageHeaderProps> = ({
  title,
  actions,
  showDivider = true,
}) => (
  <>
    <PageHeaderBar>
      <Backdoor title={title} />
      {actions ? (
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 1.5,
            flexShrink: 0,
          }}
        >
          {actions}
        </Box>
      ) : null}
    </PageHeaderBar>
    {showDivider && (
      <Divider sx={{ borderColor: APP_SHELL_HEADER_BORDER, flexShrink: 0 }} />
    )}
  </>
);
